import { useNavigate } from "react-router-dom";

import { T } from "@repo/transifex";
import { Button, DialogError } from "~/components";
import { employeeActions } from "~/providers/store/employee";
import { useInactive } from "~/hooks/use-inactive";
import { SECOND_MS } from "~/utils/constants";

export const EmployeeCardErrorPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    employeeActions.reset();
    navigate("/pos");
  };

  useInactive({
    inactiveTimeout: 5 * SECOND_MS, // 5 seconds
    onInactive: handleClose
  });

  return (
    <DialogError
      backdropVariant="error"
      error={<T _str="You don't have enough balance" />}
      hideSupport
      onOutsideClick={handleClose}
      size="md"
    >
      <p className="text-center">
        <T _str="Please top up you balance and try again. The current order has been cancelled" />
      </p>
      <Button className="w-full" onClick={handleClose} variant="danger">
        <T _str="Close" />
      </Button>
    </DialogError>
  );
};
